// Material UI
import { enUS, arSD, ruRU } from '@mui/material/locale';

// LAYOUT
// ----------------------------------------------------------------------
export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const cookiesExpires = 3;

export const cookiesKey = {
  themeMode: 'themeMode',
  themeLayout: 'themeLayout',
  themeStretch: 'themeStretch',
  themeContrast: 'themeContrast',
  themeDirection: 'themeDirection',
  themeColorPresets: 'themeColorPresets',
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'Arabic / عربى',
    value: 'ar',
    systemValue: arSD,
    fontPath: 'https://fonts.googleapis.com/css2?family=Almarai:wght@300;400;700&display=swap',
    fontFamily: '"Almarai", sans-serif',
  },
  {
    label: 'Russian / Русский',
    value: 'ru',
    systemValue: ruRU,
    fontPath: 'https://fonts.googleapis.com/css2?family=Chocolate+Classical+Sans&display=swap',
    fontFamily: '"Chocolate Classical Sans", sans-serif',
  },
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    fontPath:
      'https://fonts.googleapis.com/css2?family=Nunito+Sans:ital,opsz,wght@0,6..12,200..1000;1,6..12,200..1000&display=swap',
    fontFamily: '"Nunito Sans", sans-serif',
  },
];
export const defaultLang = allLangs[0]; // English

// INTERNAL ROUTES
// ----------------------------------------------------------------------
export const INTERNAL_PATHS = {
  auth: {
    // Login and registration
    login: '/auth/login',
    register: '/auth/register',

    // Complete registration
    verify: '/auth/verify',
    address: '/auth/address',
    phoneVerify: '/auth/phone-verify',
    profile: '/auth/profile',

    // Mfa
    mfa: '/auth/mfa',
    resetMfa: '/auth/reset-mfa',

    // Forgot and reset password
    forgotPassword: '/auth/forgot-password',
    resetPasswordMfa: '/auth/reset-password-mfa',
    resetPassword: '/auth/reset-password',
  },
  dashboard: {
    root: '/dashboard',

    sessions: '/dashboard/sessions',
  },
};

export const captchaConfig = {
  key: process.env.NEXT_PUBLIC_CAPTCHA_KEY || '338a51f1641f02383a56fb6eeaef2f0e',
};

// Invite URL
// ----------------------------------------------------------------------
export const PUBLIC_AFFILIATE_URL = 'https://jsur.capital/register';
